import React from 'react';
import { observer } from 'mobx-react-lite';
import Tree from '../tree/Tree';
import SubGroups from './SubGroups';
const Group = function Group(props) {
    const prefixCls = 'c7n-pro-table';
    const { header, records, value, onDragEnd, treeNodeRenderer, treeNodeSuffix } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `${prefixCls}-customization-tree-group-header` }, header),
        React.createElement(Tree, { value: value },
            React.createElement(SubGroups, { records: records, onDragEnd: onDragEnd, treeNodeRenderer: treeNodeRenderer, treeNodeSuffix: treeNodeSuffix }))));
};
Group.displayName = 'Group';
export default observer(Group);
